module.exports = __webpack_public_path__ + "static/media/mn25.c7eb4810.jpeg";